import {afterDomIsReady} from '../utils/whenLoaded';
import {initializeCalculatorStorage, initializePatientStorage} from '../stateHandler';
import {assert} from '../utils/assert';
import {getRangeInputByName, getRangeTickmarksByInputName} from '../utils/formFields';
import {loadTemplate} from '../utils/loadTemplate';
import {updateTickmarks} from '../utils/updateTickmarks';

export default () => afterDomIsReady(async () => {
	const templateEl = document.getElementById('nrs-template') as HTMLTextAreaElement;
	assert(templateEl !== null);
	const getTemplate = await loadTemplate(`./nrs-${templateEl.dataset.filename}-template.html`);

	const storage = initializeCalculatorStorage();

	const updateState = function (column: string, data: any) {
		storage.update('nrs', Object.assign({}, storage.get('nrs'), {
			[column]: data
		}))
	};
	const recount = () => {
		const nrs = getRangeInputByName('r1').value;
		updateTickmarks(getRangeTickmarksByInputName('r1'), nrs);
		updateState('1', nrs);

		const total = parseFloat(nrs);
		const totalAsString = total.toFixed(0);
		document.getElementById('nrs-score')!.innerText = totalAsString;
		(document.getElementById('nrs-downloadButton') as HTMLElement).removeAttribute('hidden');
		updateState('total', totalAsString);
	};

	// on every field change
	document.querySelectorAll('select,input[type=radio]').forEach(
		el => el.addEventListener('change', () => recount()));

	document.querySelectorAll('input[type=range]').forEach(
		el => el.addEventListener('input', () => recount()));
	// IE fix:
	document.querySelectorAll('input[type=range]').forEach(
		el => el.addEventListener('change', () => recount()));



	const resultEl = document.getElementById('nrs-downloadForm');
	assert(resultEl !== null);
	resultEl.addEventListener('submit', () => {
		let template = getTemplate();

		const pacient = initializePatientStorage().get();
		template = template.replace('{titul}', pacient.degree || '');
		template = template.replace('{jmeno}', pacient.firstName || '');
		template = template.replace('{prijmeni}', pacient.lastName || '');
		template = template.replace('{datumVysetreni}', pacient.examinationDate || '');

		const state = storage.get('nrs');
		template = template.replace('{r1}', state[1]);
		template = template.replace('{celkem}', state.total);

		templateEl.value = template;
	});
});
